import { axiosClient } from '@/shared/apis/config';
import { DtoFileExtension } from '@/shared/constants';
import { ApiResponse, ErrorResponse } from '@/shared/types';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { z } from 'zod';

export const postAccountProfileFormSchema = z.object({
  extension: z.nativeEnum(DtoFileExtension),
});

export type PostAccountProfileForm = z.infer<
  typeof postAccountProfileFormSchema
>;

type Response = ApiResponse<string>;

/* 계정 프로필 업로드 */
export const postAccountProfileApi = async (form: PostAccountProfileForm) => {
  try {
    const response = await axiosClient.post<Response>(
      '/v1.0/account/profile',
      form,
    );

    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const QueryKeyUsePostAccountProfile = 'postAccountProfile' as const;

export const usePostAccountProfileApi = () => {
  return useMutation<
    Response,
    AxiosError<ErrorResponse>,
    PostAccountProfileForm
  >({
    mutationFn: postAccountProfileApi,
  });
};
